// extracted by mini-css-extract-plugin
export default {"container":"r1SV5suF","pageHeader":"NUSxZXc0","title":"P1sxQ3Db","tableCard":"RGfQ_l2v","shiftIdLink":"pp7F0NGv"};